let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1er33")).then(() => parcelRequire('hklRK'));